import http, { createApi } from '@core/fetch'
const get = url => query => http(url, { body: query })
const post = url => params => http.post(url, { body: params })

export default {
  // 获取价格信息
  getPayment: () =>
    http.post('/p/wedding/index.php/admin/APIMerchantServiceVr/PayMoney'),

  // 获取购买资格
  getAuth: () =>
    http(
      '/p/wedding/index.php/Admin/APIMerchantServicePrivilege/MerchantPrivilege',
      { onError: false }
    ),

  list: ({ per_page, ...body }) =>
    http.get('/p/wedding/index.php/Admin/APIMerchantPano/panoList', {
      body: {
        ...body,
        perPage: per_page
      }
    }),
  sortList: ({ per_page, ...body }) =>
    http.get('/p/wedding/index.php/Admin/APIMerchantPano/panoList?status=1', {
      body: {
        ...body,
        perPage: per_page
      }
    }),
  deleteVR: createApi.post('/p/wedding/index.php/Admin/APIMerchantPano/delete'),
  settings: createApi.post('/p/wedding/index.php/Admin/APIMerchantPano/sort'),
  // 酒店商家场地列表
  sitelist: params =>
    http('/p/wedding/index.php/admin/APIHotelMerchant/hall_list', {
      body: params
    }),

  // 获取酒店商家vr数据
  getHotelVrInfo: get(
    '/p/wedding/index.php/admin/APIHotelMerchant/hotelVrInfo'
  ),
  // 获取酒店商家全景列表
  getPanoList: get('/p/wedding/index.php/Admin/APIHotelMerchant/panoList'),
  // 获取酒店全景数据
  getPano: get('/p/wedding/index.php/Admin/APIHotelMerchant/pano'),
  // 上传全景图
  postPanoAdd: post('/p/wedding/index.php/Admin/APIHotelMerchant/panoAdd'),
  // 删除全景
  postPanoDelete: post(
    '/p/wedding/index.php/Admin/APIHotelMerchant/panoDelete'
  ),
  // 编辑全景数据
  postPanoEdit: createApi.post(
    '/p/wedding/index.php/Admin/APIHotelMerchant/panoEdit',
    {
      ignore: [undefined]
    }
  ),
  // 获取vr信息
  getPanoDetail: get('/p/wedding/index.php/Home/APIPano/detail'),
  // 设置视角
  postPanoStartupView: post(
    '/p/wedding/index.php/Admin/APIHotelMerchant/panoStartupView'
  ),
  // 设置热点
  postPanoHotdata: post(
    '/p/wedding/index.php/Admin/APIHotelMerchant/panoHotdata'
  ),
  // 获取酒店vr权限
  getMerchantPrivilege: get(
    '/p/wedding/index.php/Admin/APIMerchantServicePrivilege/MerchantPrivilege'
  ),

  // 场景排序
  sortScenes: post('/p/wedding/index.php/Admin/APIMerchantPano/panoSceneSort'),
  // 获取审核通过的所有VR数据(过滤当前vr)
  getAllVrList: params =>
    http.get('/hms/hljHotel/appApi/admin/hotel/allVrList', {
      body: params
    })
}
